export interface IFilterInput {
	name: string
	type: "range" | "options"
	label: string
	range?: IRange
	options?: IMockOption[]
}

export interface IRange {
	min: number
	max: number
	defaultValue: [number, number]
	suffix?: string
}

export interface IMockOption {
	label: string
	value: string
}

const filterInputs: IFilterInput[] = []

export function getFilterInputs(
	rooms: number[] | null,
	price: [number, number] | null,
	square: [number, number] | null
) {
	if (rooms) {
		filterInputs.push({
			name: "rooms",
			type: "options",
			label: "Количество комнат",
			options: rooms
				.filter(room => room > 0)
				.map(room => ({ label: `${room} комнатная`, value: String(room) })),
		})
	}

	if (price) {
		filterInputs.push({
			name: "price",
			type: "range",
			label: "Цена, ₽",
			range: {
				min: price[0],
				max: price[1],
				defaultValue: price,
				suffix: "₽",
			},
		})
	}

	if (square) {
		filterInputs.push({
			name: "square",
			type: "range",
			label: "Площадь, м2",
			range: {
				min: square[0],
				max: square[1],
				defaultValue: square,
				suffix: "м2",
			},
		})
	}

	return filterInputs
}
